<!-- A place to view and test components in development -->
<!-- For internal users only -->
<!-- Keep this clean! Remove components under test when done. -->

<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-gap-5">
    <h1 class="tw-text-xl">
      DevelopmentView
    </h1>

    <div style="width: 260px;">
      <AutocompleteWithFetch
        v-slot="{ item }"
        endpoint="/api/v1/prospects"
        results-field="prospects"
        :multiple="true"
        @selection-change="handleSelectionChange"
      >
        <div>
          <p class="tw-text-xs tw-text-gray-400">
            {{ item.id }}
          </p>
          <p>{{ item.name }}</p>
        </div>
      </AutocompleteWithFetch>
    </div>
  </div>
</template>


<script setup>
import AutocompleteWithFetch from '@frontend/ui/components/utils/AutocompleteWithFetch.vue';

const handleSelectionChange = selected => {
  console.log('Selected:', selected);
};
</script>
